import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import BankListsWrapper from './BankListsWrapper';
import { getKey, clientMessage, isAddNPay, staticPath, equalsIgnoreCase } from '../../utils/common';
import CONSTANT, { CACHE } from '../../utils/constants';
import { postInWindow } from '../../utils/formPost';
import { PAYMODE } from '../../../../common/src/constant';
import { EVENT, log } from '../../common/logger';
import Renewal from '../subscription/renewal';
import PaymodeOffer from '../offers/paymodeOffer';

class Nb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtherBanks: false,
      selectedBank: null,
      bankListsData: {},
      filterBankData: {},
      showFilteredData: false,
      isSearchFocused: false,
      showError: false,
      errorText: ''
    };
    this.defaultState = JSON.parse(JSON.stringify(this.state));
    this.prevOPtionsSelected = '';
    this.bankOptionsSelected = '';
    this.isSearchFocusedLogged = false;
    const locale = clientMessage(PAYMODE.NB.toLowerCase(), this.props.cache);
    this.label = locale.label;
    this.error = locale.error;
  }

  componentDidMount = () => {
    const banks = getKey(this.props, 'option.data.banks', []);
    const selectedType = getKey(this.props, 'selected.type', null);

    if (selectedType && equalsIgnoreCase(selectedType, PAYMODE.NB) && banks.length) {
      this.bankOptionClick(banks[0]);
    }
  };

  componentDidUpdate(previousProps) {
    const selected = getKey(this.props, 'selected', null);
    const option = getKey(this.props, 'option', null);
    if (
      !this.props.cache.getData(CACHE.SELECTEDBANK) &&
      selected &&
      option &&
      selected.id === option.id
    ) {
      // set selected bank in cache if not there on render
      this.props.cache.setData(CACHE.SELECTEDBANK, this.state.selectedBank);
    }
    if (
      selected &&
      equalsIgnoreCase(selected.type, PAYMODE.NB) &&
      previousProps.selected !== this.props.selected
    ) {
      this.setState(this.defaultState, () => {
        if (this.props.option.data.banks && this.props.option.data.banks.length > 0) {
          this.bankOptionClick(this.props.option.data.banks[0]);
        }
      });
    }
  }

  bankOptionClick = bank => {
    this.props.cache.getData(CACHE.STORE).setState({ stopScroll: false });
    if (getKey(bank, 'hasLowSuccess.status', false)) {
      log({ eventType: EVENT.NB_BANK_SELECTED, hasLowSuccess: true, bankName: bank.channelName });
    } else {
      log({ eventType: EVENT.NB_BANK_SELECTED, hasLowSuccess: false, bankName: bank.channelName });
    }
    this.setState({ selectedBank: bank, showOtherBanks: false });
    if (bank.channelCode !== this.prevOPtionsSelected) {
      this.bankOptionsSelected += `${bank.channelCode}|`;
      this.prevOPtionsSelected = bank.channelCode;
    }
    this.props.cache.setData(CACHE.SELECTEDBANK, bank);
    this.props.onPayChange(true);
    this.props.updateSelectedPayModePcfWithInstId(bank.channelCode);
    this.props.applyPromoForPayMode(this.props.option, bank.channelCode);
    // clearing the search since on reopening the bank list  after selecting a bank only filtered bank list was shown
    this.clearSeacrh();
  };

  submit = () => {
    if (this.state.selectedBank) {
      const payload = {
        paymentMode: CONSTANT.NB,
        channelCode: this.state.selectedBank.channelCode,
        authMode: CONSTANT['3D'],
        selectedPaymentModeId: this.props.option.id
      };
      this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
      this.props.cache
        .getData(CACHE.API)
        .pay(payload)
        .then(response => {
          const notifyMerchant = getKey(
            this.props.cache.getData(CACHE.MERCHANT_CONFIG),
            'handler.notifyMerchant',
            undefined
          );
          if (getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
            const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', {});
            response.body.content = content;
            response.body.callbackUrl = actionUrl;
          } else {
            const errorMsg = getKey(response, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
            if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
              notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, response);
            }
            this.setState({ showError: true, errorText: errorMsg });
          }
          postInWindow(response, this.props.cache);
        })
        .catch(err => {
          const notifyMerchant = getKey(
            this.props.cache.getData(CACHE.MERCHANT_CONFIG),
            'handler.notifyMerchant',
            undefined
          );
          this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
          this.setState(prevState => ({ showError: true, errorText: prevState.genericErrorMsg }));
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, err);
          }
          postInWindow({}, this.props.cache); // close window in case of network error
        });
    }
  };

  showMoreBankLists = () => {
    if (!this.state.bankListsData.length) {
      const paymentOptions = this.props.cache.getData('paymentOptions');
      this.props.cache
        .getData(CACHE.API)
        .nbChannels(isAddNPay(paymentOptions, this.props.cache))
        .then(res => {
          if (res && getKey(res, 'body.nbPayOption.payChannelOptions')) {
            this.setState({
              bankListsData: res.body.nbPayOption.payChannelOptions,
              showOtherBanks: true
            });
            this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
          }
        });
    } else {
      this.setState({ showOtherBanks: true });
      this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
    }
  };

  cancel = () => {
    if (document.getElementById('searchBar')) {
      document.getElementById('searchBar').value = '';
      document.getElementById('searchBar').blur();
    }
    this.setState(prevState => ({
      showOtherBanks: !prevState.showOtherBanks,
      filterBankData: {},
      showFilteredData: false,
      isSearchFocused: false
    }));
    this.props.onStopScroll(false);
  };

  _filterBanks = (value, data) => {
    const result = data.filter(record => {
      const bankName = record.displayName ? 'displayName' : 'channelName';
      return record[bankName].toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });
    return result;
  };

  filterBanks = e => {
    if (e.currentTarget.value) {
      // const filterBankData = this._filterBanks(e.currentTarget.value, this.state.bankListsData);
      // this.setState({ filterBankData, showFilteredData: true });
      this.setState(prevState => ({
        filterBankData: this._filterBanks(e.currentTarget.value, prevState.bankListsData),
        showFilteredData: true
      }));
    } else {
      this.setState(prevState => ({
        filterBankData: {},
        bankListsData: prevState.bankListsData,
        showFilteredData: false
      }));
    }
  };

  _filterByAlphabet = (alphabet, data) => {
    return data.filter(record => {
      const bankName = record[record.displayName ? 'displayName' : 'channelName'].toLowerCase();
      return !!(bankName && bankName.charAt(0) === alphabet.toLowerCase());
    });
  };

  clearSeacrh = () => {
    this.setState({ filterBankData: [], showFilteredData: false, isSearchFocused: false });
  };

  alphabetFilter = alphabet => {
    // const filterBankData = this._filterByAlphabet(alphabet, this.state.bankListsData);
    // this.setState({ filterBankData, showFilteredData: true });
    this.setState(prevState => ({
      filterBankData: this._filterByAlphabet(alphabet, prevState.bankListsData),
      showFilteredData: true
    }));
  };

  focusIn = () => {
    if (!this.isSearchFocusedLogged) {
      this.isSearchFocusedLogged = true;
    }
    this.setState({ isSearchFocused: true });
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
    this.props.onPayChange(true);
  };

  render(
    { option, instanceKey, isActive, offers, cache },
    {
      selectedBank,
      bankListsData,
      showOtherBanks,
      filterBankData,
      showFilteredData,
      isSearchFocused,
      showError,
      errorText
    }
  ) {
    let isBankInList = false;
    const nbOffer = getKey(offers, CONSTANT.NB);
    const iconBaseUrl = cache.getData(CONSTANT.ICON_BASE_URL);

    return (
      <div
        className={`${showOtherBanks ? 'ptm-nb-banks-opened' : ''} `}
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div className="ptm-pay-method ptm-w100-ib" id="checkout-nb">
          <div className="ptm-radio-wrap ptm-pt11">
            <label className="ptm-lbl">
              <input
                type="radio"
                name={`verify${instanceKey}`}
                className="ptm-margin0"
                checked={isActive}
                onClick={() => {
                  this.onOptionSelect(option);
                }}
              />
              <span class="ptm-checkmark" />
              <div class={`ptm-pay-method-cont`}>
                <p class={`ptm-paymode-name `}>{option.displayName}</p>
              </div>
            </label>
          </div>
          {/* nb inner */}
          {option && isActive && (
            <div className={`ptm-nb-inner ptm-pl-35`} id="ptm-nb-inner">
              <div className={`ptm-nb-list ptm-w100-ib`}>
                {option.data &&
                  getKey(option.data, 'banks') &&
                  option.data.banks.map(bank => (
                    <div
                      className={`ptm-nb-list-item paytm-txt-center`}
                      onClick={() => this.bankOptionClick(bank)}
                    >
                      <div
                        className={`ptm-pos-r ptm-nb-img ${
                          selectedBank && bank.channelName === selectedBank.channelName
                            ? (isBankInList = true) && 'ptm-activeBank'
                            : ''
                        }`}
                      >
                        <img className={`ptm-pos-a`} src={iconBaseUrl + bank.iconUrl} alt="" />
                        {selectedBank && bank.channelName === selectedBank.channelName && (
                          <div className={`ptm-tick ptm-pos-a`}>
                            <span className={`ptm-sign1`} />
                            <span className={`ptm-sign2`} />
                          </div>
                        )}
                      </div>
                      <p className={`ptm-bank-name ptm-body-color`}>{bank.channelCode}</p>
                    </div>
                  ))}
              </div>
              {nbOffer && selectedBank && isBankInList && (
                <PaymodeOffer offer={nbOffer} noLeftPadding={true} />
              )}
              <div className={`ptm-nb-select ptm-global-border`} onClick={this.showMoreBankLists}>
                <h3 className={`ptm-nb-select-heading ptm-body-color`}>
                  {selectedBank && !isBankInList && (
                    <span className={`ptm-pos-r ptm-global-border`}>
                      {selectedBank && (
                        <img
                          className={`ptm-centralized ptm-pos-a ptm-margin0`}
                          src={iconBaseUrl + selectedBank.iconUrl}
                        />
                      )}
                    </span>
                  )}
                  {selectedBank && !isBankInList
                    ? selectedBank.channelName
                    : 'Select From Other Banks'}
                  <img
                    className="ptm-right ptm-margin0"
                    src={`${staticPath()}/assets/images/ic-dropdown-light.svg`}
                    alt=""
                  />
                </h3>
              </div>
              {nbOffer && selectedBank && !isBankInList && (
                <PaymodeOffer offer={nbOffer} noLeftPadding={true} />
              )}
              <p className={`ptm-nb-select-para ptm-body-color`}>
                {this.label.secureRedirectionMessage}
              </p>
              {option && isActive && <Renewal />}
              {showError ? <p className="ptm-msg-red">{errorText}</p> : null}
            </div>
          )}
        </div>
        {showOtherBanks && (
          <BankListsWrapper
            bankListsData={bankListsData}
            filterBankData={filterBankData}
            cancel={this.cancel}
            filterBanks={this.filterBanks}
            BankOptionClick={this.bankOptionClick}
            showFilteredData={showFilteredData}
            alphabetFilter={this.alphabetFilter}
            isSearchFocused={isSearchFocused}
            focusIn={this.focusIn}
            clearSeacrh={this.clearSeacrh}
          />
        )}
      </div>
    );
  }
}
export default connect(
  'selected, cache, instanceKey',
  onChange
)(Nb);



// WEBPACK FOOTER //
// ./components/nb/index.js